
import { useEffect, useMemo, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';

import { database } from "../../../services/firebase-config";

import styles from "./styles.module.css"
import BookItem from "../BookItem";
import BookCreateButton from "../BookCreateButton";
import DataTable from 'react-data-table-component';


export default function ListBooks({ collectionName, isVirtual }) {

    let count = 0;

    const [ebooks, setEbooks] = useState([]);
    const ebookCollectionRef = collection(database, collectionName);
    const [updateTable, setUpdateTable] = useState(1);


    function updateTableData() {
        setUpdateTable(updateTable + 1);
        console.log('UpdateFirebaseData');
    }

    useEffect(() => {
        const getEbooks = async () => {
            const data = await getDocs(ebookCollectionRef);
            setEbooks(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            console.log("getFirebaseData");
        }
        getEbooks();

    }, [updateTable]);


    const columns = [
        {
            name: 'Nome',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Preço',
            selector: row => row.price,
            sortable: true,
        },
        {
            name: 'Desconto',
            selector: row => row.discount,
            sortable: true,
        },
        {
            name: 'Em amostra',
            selector: row => row.free,
        },
        {
            name: 'Ativo',
            selector: row => row.active,
        },
        {
            name: '  ',
            selector: row => row.options,
            style: {
                justifyContent: 'flex-end',
                minWidth: '200px'
            }
        },
    ];



    const paginationComponentOptions = {
        rowsPerPageText: 'E-books por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };



    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = ebooks.filter(
        ebook => ebook.name && ebook.name.toLowerCase().includes(filterText.toLowerCase()),
    );

    const data = filteredItems.map(
        (ebook) => {
            return {
                name: ebook.name,
                price: `R$ ${ebook.price}`,
                discount: `% ${ebook.discount}`,
                free: ebook.free ? 'Amostra grátis' : 'Versão paga',
                active: ebook.active ? "Ativado" : "Desativado",
                options: <BookItem key={ebook.id} count={count++} bookData={ebook} collection={collectionName} isVirtual={isVirtual} updateTableData={updateTableData} />

            }
        }
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className={styles.filterTable}>
                <label htmlFor="filtro">Buscar: </label>
                <input id='filtro' name='filtro' placeholder='Nome do e-book...' onChange={e => setFilterText(e.target.value)} value={filterText} />
            </div>

        );
    }, [filterText, resetPaginationToggle]);


    return (
        <div className={styles.ListContainer}>
            <div className={styles.ControlsContainer}>
                <BookCreateButton updateTableData={updateTableData} collectionRef={ebookCollectionRef} isVirtual={isVirtual} />
                {subHeaderComponentMemo}
            </div>
            <DataTable
                title="E-books"
                pagination
                paginationComponentOptions={paginationComponentOptions}
                columns={columns}
                noDataComponent="Nenhum e-book encontrado"
                data={data} />
        </div>
    );
}